import * as React from "react";
import { HeaderSearchResults } from "../HeaderSearchResults";

export function StackedLayout({
  settings,
  query,
  productsTotal,
  articlesTotal,
  isMobile,
  articles,
  products,
  showSeeAllProductsAtBottom,
}) {
  return (
    <div className="header-search-results-stacked">
      {/* Products Section */}
      <div className="header-search-section mb-6">
        <div className="header-search__stacked flex justify-between items-center">
          <div className="flex w-full lg:w-auto justify-between">
            <p className="text-sm lg:text-base font-medium">
              Product Results ( {productsTotal} )
            </p>
          </div>

          {productsTotal > 0 &&
            <div className="hidden lg:flex gap-x-[8px] items-center">
              <a href={`/search?q=${query}&type=product`} className="b2 button-text flex items-center gap-2 hover:underline">
                <span>Show All Product Results</span>
                <i className="icon icon-ur-arrow text-[19px]"></i>
              </a>
            </div>
          }
        </div>

        {products && products.length > 0 ? (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-2 lg:gap-x-5 gap-y-4 lg:gap-y-10 lg:overflow-y-auto pt-4 lg:pt-6">
              <HeaderSearchResults
                settings={settings}
                results={products}
                type={"products"}
              />
            </div>

            {isMobile && (
              <div className="flex justify-center gap-2 mt-4">
                <a
                  href={`/search?q=${query}`}
                  className="b3 button-text flex items-center gap-2"
                >
                  <span className="hover:underline">Show All Results</span>
                  <i className="icon icon-ur-arrow text-[19px]"></i>
                </a>
              </div>
            )}
          </>
        ) : (
          <p className="text-sm italic pt-3">No products found matching your search.</p>
        )}
      </div>

      {/* Articles Section */}
      {articles && articlesTotal > 0 && (
        <div className="header-search-section">
          <div className="header-search__stacked flex justify-between items-center">
            <div className="flex w-full lg:w-auto justify-between">
              <p className="text-sm lg:text-base font-medium">
                Blog Results ( {articlesTotal} )
              </p>
            </div>
            
            <div className="hidden lg:flex gap-x-[8px] items-center">
              <a href={`/search?q=${query}&type=article`} className="b2 button-text flex items-center gap-2 hover:underline">
                <span>Show All Blog Results</span>
                <i className="icon icon-ur-arrow text-[19px]"></i>
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-2 lg:gap-x-5 gap-y-4 lg:gap-y-10 lg:overflow-y-auto pb-4 pt-4 lg:pt-6">
            <HeaderSearchResults
              settings={settings}
              results={articles}
              type={"articles"}
            />
          </div>
        </div>
      )}

      {/* See All Results Footer (only on desktop when needed) */}
      {!isMobile && showSeeAllProductsAtBottom && products && (
        <div className="flex justify-center gap-2 mt-6 pt-4 border-t">
          <a
            href={`/search?q=${query}`}
            className="button btn-primary hover:no-underline"
          >
            See All Results ({productsTotal + articlesTotal})
          </a>
        </div>
      )}
    </div>
  );
}
